import { useEffect, useState } from "react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

/**
 * InkLedgerBlock — Coffin Nail #44. Quill's spend, broken out by mode.
 * Public. Not the drafts, just the meter.
 */
export default function InkLedgerBlock() {
  const [d, setD] = useState(null);
  const [err, setErr] = useState(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const r = await fetch(`${BACKEND_URL}/api/quill/ink-ledger`);
        if (!r.ok) throw new Error(`HTTP ${r.status}`);
        const j = await r.json();
        if (!cancelled) setD(j);
      } catch (e) {
        if (!cancelled) setErr(e.message);
      }
    })();
    return () => { cancelled = true; };
  }, []);

  if (err) {
    return (
      <div data-testid="ink-ledger-error" className="border border-sage-warn p-4 text-xs text-sage-warn">
        Ink Ledger unavailable · {err}
      </div>
    );
  }
  if (!d) {
    return <div data-testid="ink-ledger-loading" className="border border-sage-border p-4 text-xs text-sage-faint">Loading Ink Ledger…</div>;
  }

  return (
    <div className="border border-sage-border p-6" data-testid="ink-ledger-block">
      <div className="flex items-baseline justify-between flex-wrap gap-2 mb-4">
        <div className="text-xs uppercase tracking-[0.2em] text-sage-muted">
          The Ink Ledger · Quill's spend
        </div>
        <div className="text-[10px] uppercase tracking-[0.15em] text-sage-faint tabular-nums">
          {d.total_turns} turns · {d.works_filed_total} works filed · ${d.total_cost_usd.toFixed(6)}
        </div>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-3 gap-3 mb-5">
        {d.by_mode.length === 0 && (
          <div className="col-span-full text-sm text-sage-faint" data-testid="ink-ledger-empty">
            Quill has not written anything yet.
          </div>
        )}
        {d.by_mode.map((row) => (
          <div key={row.mode} className="border border-sage-border p-3" data-testid={`ink-ledger-mode-${row.mode}`}>
            <div className="text-[10px] uppercase tracking-[0.2em] text-sage-faint">{row.mode}</div>
            <div className="text-xl font-bold text-sage-accent tabular-nums mt-1">
              ${row.cost_usd.toFixed(6)}
            </div>
            <div className="text-[10px] text-sage-muted tabular-nums mt-1">
              {row.turns} turns · {(row.chars_out || 0).toLocaleString()} chars · filed {d.works_filed_by_mode[row.mode] ?? 0}
            </div>
          </div>
        ))}
      </div>

      <p className="text-sm text-sage-muted leading-relaxed sage-prose" data-testid="ink-ledger-letter">
        {d.letter}
      </p>
      <div className="mt-3 text-[10px] uppercase tracking-[0.15em] text-sage-faint">
        Law: {d.law}
      </div>
    </div>
  );
}
